/* Converted to vanilla JS */

// TODO: Change this to use a single RFP Form. Taken directly from rfp-form-multiple
document.addEventListener('DOMContentLoaded', function () {
    var offset = 60;
    var currentiFrameHeight = 0;

    window.addEventListener('resize', function () {
        //resizeIFrame();
    });

    setInterval(function () { resizeIFrame(); }, 250);

    function resizeIFrame() {
        var activeWrapper = document.querySelector('.control-rfp-form-single .hotel-form-wrapper');
        if (!activeWrapper) return;
        var activeiFrame = activeWrapper.querySelector('.scsiFrame');
        if (activeiFrame) {
            try {
                var thisiFrameHeight = activeiFrame.contentWindow.document.querySelector('#rc-portal').offsetHeight + offset;
                activeWrapper.style.height = thisiFrameHeight + 'px';

                if (thisiFrameHeight < currentiFrameHeight && (currentiFrameHeight - thisiFrameHeight) > 250) {
                    var target = document.getElementById('rfpFormSelector');
                    if (target) {
                        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
                        window.scrollTo({ top: top, behavior: 'smooth' });
                    }
                }
                currentiFrameHeight = thisiFrameHeight;
            } catch (e) { }
        }
    }
});
